import Land from '../assets/imgs/landing.jpg'

export const favorit = [
  {
    id: 1,
    img: Land,
    titles: "New Apartment Nice Wiew",
    location: "Quincy St, Brooklyn, NY, USA",
    oldcost: "$2,800/mo",
    cost: "$7,500/mo",
  },
  {
    id: 2,
    img: Land,
    titles: "New Apartment Nice Wiew",
    location: "Quincy St, Brooklyn, NY, USA",
    oldcost: "$2,800/mo",
    cost: "$7,500/mo",
  },
  {
    id: 3,
    img: Land,
    titles: "New Apartment Nice Wiew",
    location: "Quincy St, Brooklyn, NY, USA",
    oldcost: "$2,800/mo",
    cost: "$7,500/mo",
  },
  {
    id: 4,
    img: Land,
    titles: "New Apartment Nice Wiew",
    location: "Quincy St, Brooklyn, NY, USA",
    oldcost: "$2,800/mo",
    cost: "$7,500/mo",
  },
  {
    id: 5,
    img: Land,
    titles: "New Apartment Nice Wiew",
    location: "Quincy St, Brooklyn, NY, USA",
    oldcost: "$2,800/mo",
    cost: "$7,500/mo",
  },
];
